import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { CHANGE_SIGN, changeToneClass, type ChangeKind } from "../styles/changeStyles";
import { classNames } from "../styles/classNames";

/** The sign of a change, hidden from screen readers, which hear its kind in words instead. */
export function ChangeMark({ kind }: { kind: ChangeKind }) {
  const { t } = useTranslation();
  return (
    <>
      <span aria-hidden={true} className="select-none">{CHANGE_SIGN[kind]} </span>
      {kind === "unchanged" ? null : <span className="sr-only">{t(`common.changes.${kind}`)} </span>}
    </>
  );
}

interface ChangeRowProps {
  kind: ChangeKind;
  /** The full value or source line, shown on hover where the row shortens it. */
  title?: string;
  className?: string;
  children: ReactNode;
}

/**
 * One change in a list of changes: its colour, its sign and its kind in words, then the
 * domain's own description (a field path, a triple, a Workflow step). Render it inside a
 * `<ul>`; the list says what changed between which versions.
 */
export default function ChangeRow({ kind, title, className, children }: ChangeRowProps) {
  return (
    <li className={classNames("rounded px-2 py-0.5", changeToneClass(kind), className)} title={title}>
      <ChangeMark kind={kind} />
      {children}
    </li>
  );
}
